export default __webpack_public_path__ + "static/media/product-tour8.902e910a.svg";